const header = document.querySelector(".header");

function toggleMobileNav() {
    const navToggles = Array.from(document.querySelectorAll("[data-nav-toggle]"));

    navToggles.forEach((toggle) => {
        toggle.addEventListener("click", (ev) => {
            ev.preventDefault();

            if (document.body.classList.contains("search-open")) {
                document.body.classList.remove("search-open");
            } else {
                if (document.body.classList.contains("nav-open")) {
                    document.body.classList.remove("nav-open");
                } else {
                    document.body.classList.add("nav-open");
                }
            }
        });
    });
}

function toggleSearchNav() {
    const searchButtons = Array.from(document.querySelectorAll("[data-search-open]"));

    searchButtons.forEach((button) => {
        button.addEventListener("click", (ev) => {
            ev.preventDefault();

            document.body.classList.add("search-open");
            document.body.classList.remove("nav-open");
        });
    });
}

function toggleSubNav() {
    const navigations = Array.from(document.querySelectorAll(".main-nav__item"));

    navigations.forEach((navigation) => {
        const toggle = navigation.querySelector("[data-toggle-subnav]");

        if (toggle) {
            toggle.addEventListener("click", (ev) => {
                if (document.documentElement.clientWidth <= 899) {
                    ev.preventDefault();
                    navigation.classList.toggle("main-nav__item--active");
                }
            });
        }
    });
}

export default function () {
    if (header) {
        toggleMobileNav();
        toggleSearchNav();
        toggleSubNav();
    }
}
